var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39412 0.580237C1.92583 0.204864 2.55929 0 3.21421 0H26.7856C27.4406 0 28.074 0.204875 28.6057 0.580237L15.6882 11.7193C15.2905 12.063 14.7092 12.063 14.3115 11.7193L1.39412 0.580237ZM29.8688 2.36361C29.9545 2.66473 30 2.97961 30 3.3V18.7C30 19.5759 29.6612 20.4146 29.0585 21.0334C28.4558 21.6521 27.6388 22 26.7857 22H3.21429C2.36115 22 1.54419 21.6521 0.94152 21.0334C0.338846 20.4146 0 19.5759 0 18.7V3.3C0 2.97962 0.0455347 2.66475 0.131249 2.36361L12.9322 13.4034C14.1282 14.4346 15.8719 14.4346 17.0677 13.4034L29.8688 2.36361Z",
    fill: "url(#paint0_linear_4046_8222)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4046_8222",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contactUs.3d09bb6721d1376996a40be7f520cce6.svg";
export { ForwardRef as ReactComponent };